// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.QnbHml {
  display: flex;
  flex-direction: column;
  gap: 24px;
}

.narbOq {
  display: flex;
  align-items: flex-start;
  gap: 12px;
  padding: 12px 16px;
  background-color: #e3f2fd;
  border-radius: 8px;
  border-left: 4px solid #2196f3;
}

.gACjAx {
  flex-shrink: 0;
  width: 20px;
  height: 20px;
  color: #2196f3;
}

.h2qN82 {
  font-size: 14px;
  line-height: 1.5;
  color: #333;
}

.p5KppM {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.gWQx1_ {
  font-size: 16px;
  font-weight: 600;
  color: #333;
  margin: 0;
}

.OomSqu {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.FPO7FX {
  font-size: 14px;
  color: #666;
}

._RTut5 {
  width: 100%;
}

.aZIO7j {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 12px;
  color: #ff9800;
  margin-top: 4px;
}

.bNRsEt {
  width: 16px;
  height: 16px;
}

.b0zrXe {
  display: flex;
  gap: 12px;
  margin-top: 32px;
  padding-top: 24px;
  border-top: 1px solid #e0e0e0;
}

.b0zrXe > * {
  flex: 1;
}

.BWWR6O {
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 48px;
}

.PddmFA {
  display: flex;
  align-items: flex-start;
  gap: 4px;
  font-size: 12px;
  color: #666;
  margin-top: 4px;
  line-height: 1.4;
}

.oKhtRH {
  display: flex;
  align-items: flex-start;
  gap: 4px;
  font-size: 12px;
  color: #d32f2f;
  margin-top: 4px;
  line-height: 1.4;
}
`, "",{"version":3,"sources":["webpack://./../../packages/pagamentos/src/components/LimitsEditor/LimitsEditor.module.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,kBAAkB;EAClB,yBAAyB;EACzB,kBAAkB;EAClB,8BAA8B;AAChC;;AAEA;EACE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,aAAa;EACb,SAAS;EACT,gBAAgB;EAChB,iBAAiB;EACjB,6BAA6B;AAC/B;;AAEA;EACE,OAAO;AACT;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,QAAQ;EACR,eAAe;EACf,WAAW;EACX,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,QAAQ;EACR,eAAe;EACf,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB","sourcesContent":[".container {\n  display: flex;\n  flex-direction: column;\n  gap: 24px;\n}\n\n.alert {\n  display: flex;\n  align-items: flex-start;\n  gap: 12px;\n  padding: 12px 16px;\n  background-color: #e3f2fd;\n  border-radius: 8px;\n  border-left: 4px solid #2196f3;\n}\n\n.alertIcon {\n  flex-shrink: 0;\n  width: 20px;\n  height: 20px;\n  color: #2196f3;\n}\n\n.alertText {\n  font-size: 14px;\n  line-height: 1.5;\n  color: #333;\n}\n\n.section {\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n}\n\n.sectionTitle {\n  font-size: 16px;\n  font-weight: 600;\n  color: #333;\n  margin: 0;\n}\n\n.limitRow {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n}\n\n.limitLabel {\n  font-size: 14px;\n  color: #666;\n}\n\n.limitInput {\n  width: 100%;\n}\n\n.pendingNotice {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  font-size: 12px;\n  color: #ff9800;\n  margin-top: 4px;\n}\n\n.pendingIcon {\n  width: 16px;\n  height: 16px;\n}\n\n.actions {\n  display: flex;\n  gap: 12px;\n  margin-top: 32px;\n  padding-top: 24px;\n  border-top: 1px solid #e0e0e0;\n}\n\n.actions > * {\n  flex: 1;\n}\n\n.loading {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  padding: 48px;\n}\n\n.validationMessage {\n  display: flex;\n  align-items: flex-start;\n  gap: 4px;\n  font-size: 12px;\n  color: #666;\n  margin-top: 4px;\n  line-height: 1.4;\n}\n\n.validationError {\n  display: flex;\n  align-items: flex-start;\n  gap: 4px;\n  font-size: 12px;\n  color: #d32f2f;\n  margin-top: 4px;\n  line-height: 1.4;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `QnbHml`,
	"alert": `narbOq`,
	"alertIcon": `gACjAx`,
	"alertText": `h2qN82`,
	"section": `p5KppM`,
	"sectionTitle": `gWQx1_`,
	"limitRow": `OomSqu`,
	"limitLabel": `FPO7FX`,
	"limitInput": `_RTut5`,
	"pendingNotice": `aZIO7j`,
	"pendingIcon": `bNRsEt`,
	"actions": `b0zrXe`,
	"loading": `BWWR6O`,
	"validationMessage": `PddmFA`,
	"validationError": `oKhtRH`
};
module.exports = ___CSS_LOADER_EXPORT___;
